"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FactoryMostlyFluid = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var type_guard_1 = require("@webnuts/type-guard");
var react_1 = __importDefault(require("react"));
// eslint-disable-next-line no-restricted-imports
var styled_components_1 = __importStar(require("styled-components"));
var css_types_1 = require("../../internal/css-types");
var factory_1 = require("../../internal/factory");
var factory_utils_1 = require("../../internal/factory-utils");
var invertMargin = function (margin) {
    return margin == null ? margin : margin.startsWith('-') ? margin.slice(1) : "-" + margin;
};
var SETTINGS = {
    widths: type_guard_1.optional(type_guard_1.array({ items: css_types_1.measureUnit, length: { min: 1 } })),
    justifyContent: type_guard_1.optional(css_types_1.justifyContent),
    alignItems: type_guard_1.optional(css_types_1.alignItems),
    horizontalPadding: type_guard_1.optional(css_types_1.measureUnit),
    verticalPadding: type_guard_1.optional(css_types_1.measureUnit)
};
exports.FactoryMostlyFluid = factory_1.factory({
    prefix: 'MostlyFluid',
    settings: __assign(__assign({}, SETTINGS), { breakpoints: factory_utils_1.makeBreakpointSettings(SETTINGS) }),
    component: function (settings, utils) {
        var Container = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      box-sizing: border-box;\n      display: flex;\n      flex-wrap: wrap;\n      width: 100%;\n\n      ", "\n    "], ["\n      box-sizing: border-box;\n      display: flex;\n      flex-wrap: wrap;\n      width: 100%;\n\n      ", "\n    "])), function (_a) {
            var $settings = _a.$settings;
            return utils.css.breakpoint($settings.breakpoints, $settings, function (_a) {
                var horizontalPadding = _a.horizontalPadding, verticalPadding = _a.verticalPadding, justifyContent = _a.justifyContent, alignItems = _a.alignItems;
                var widthStr = ['100%', horizontalPadding].filter(function (e) { return e != null; }).join(' + ');
                return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n              ", "\n              ", "\n              ", "\n              ", "\n\n              /* This check is required to avoid breaking the non-breakpoint with\n                inherited, when padding is not defined for the current breakpoint. */\n              ", "\n            "], ["\n              ", "\n              ", "\n              ", "\n              ", "\n\n              /* This check is required to avoid breaking the non-breakpoint with\n                inherited, when padding is not defined for the current breakpoint. */\n              ", "\n            "])), utils.css.rule('margin-left', invertMargin(horizontalPadding)), utils.css.rule('margin-top', invertMargin(verticalPadding)), utils.css.rule('justify-content', justifyContent), utils.css.rule('align-items', alignItems), widthStr !== '100%' && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                width: calc(", ");\n              "], ["\n                width: calc(", ");\n              "])), widthStr));
            });
        });
        Container.displayName = 'MostlyFluid.Container';
        var Item = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      box-sizing: border-box;\n\n      ", "\n    "], ["\n      box-sizing: border-box;\n\n      ", "\n    "])), function (_a) {
            var $index = _a.$index, $settings = _a.$settings;
            return utils.css.breakpoint($settings.breakpoints, $settings, function (_a) {
                var widths = _a.widths, horizontalPadding = _a.horizontalPadding, verticalPadding = _a.verticalPadding;
                return styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n              ", "\n              ", "\n\n              /* Keep in mind how the index in widths cycles based on modulus\n                 of the length. */\n              ", "\n            "], ["\n              ", "\n              ", "\n\n              /* Keep in mind how the index in widths cycles based on modulus\n                 of the length. */\n              ", "\n            "])), utils.css.rule('padding-left', horizontalPadding), utils.css.rule('padding-top', verticalPadding), widths != null && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n                width: ", ";\n              "], ["\n                width: ", ";\n              "])), widths[$index % widths.length]));
            });
        });
        Item.displayName = 'MostlyFluid.item';
        return react_1.default.forwardRef(function (_a, ref) {
            var children = _a.children, props = __rest(_a, ["children"]);
            return (jsx_runtime_1.jsx(Container, __assign({ "$settings": settings, ref: ref }, props, { children: react_1.default.Children.map(children, function (child, index) { return (jsx_runtime_1.jsx(Item, __assign({ "$settings": settings, "$index": index }, { children: child }), void 0)); }) }), void 0));
        });
    }
}).FactoryMostlyFluid;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
